import { Component } from '@angular/core';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { RegistroRecente } from '../services/registro-jornada.service';
import { SolicitacaoFeriasComponent } from './solicitacao-ferias/solicitacao-ferias.component';
import { RegistrarPonto, RegistroPontoService, SaldoDiario } from '../services/registro-jornada.service';
import { HeaderComponent } from '../shared/header/header.component';

@Component({
  selector: 'app-ponto-dashboard',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, SolicitacaoFeriasComponent, HeaderComponent],
  templateUrl: './ponto-dashboard.component.html',
  styleUrl: './ponto-dashboard.component.scss'
})
export class PontoDashboardComponent {

  ultimoRegistro: string | null = null;
  showSolicitacaoFeriasModal: boolean = false;
  registros: RegistroRecente[] = [];
resumo:any;

constructor(private registroPontoService: RegistroPontoService, private toastr: ToastrService) {}
 ngOnInit(): void {
    this.carregarRegistros();
    this.carregarResumo();
  }
  carregarRegistros() { 
  this.registroPontoService.getRegistrosRecentes(7)
    .subscribe({
      next: (res) => this.registros = res,
      error: (err) => console.error('Erro ao carregar histórico', err)
    });
}
carregarResumo() {
  this.registroPontoService.getResumo()
    .subscribe({
      next: (res) => this.resumo = res,
      error: (err) => console.error('Erro ao carregar resumo', err)
    });
}

  abrirModalFerias() {
    this.showSolicitacaoFeriasModal = true;
  }

  fecharModalFerias() {
    this.showSolicitacaoFeriasModal = false;
  }

  formatarHora(data: string | null): string {
    if (!data) return '--:--';
    return new Date(data).toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatarData(data: string): string {
    return new Date(data).toLocaleDateString('pt-BR');
  }
  registrarHorario() {
  this.registroPontoService.getUltimoRegistro()
    .subscribe((ultimoTipo: number | null) => {

      let proximoTipo = 1;

      switch (ultimoTipo) {
        case 1: proximoTipo = 2; break;
        case 2: proximoTipo = 3; break;
        case 3: proximoTipo = 6; break;
        case 6: proximoTipo = 1; break;
      }

      const payload = {
        idTipoRegistro: proximoTipo
      };

      console.log('Payload enviado:', payload);

      this.registroPontoService.registrarPonto(payload)
        .subscribe({
          next: () => {
            this.ultimoRegistro = new Date().toLocaleTimeString('pt-BR', {
              hour: '2-digit',
              minute: '2-digit'
            });

            this.toastr.success(
              'Horário registrado com sucesso!',
              'Registro confirmado'
            );

            this.carregarRegistros();
          },
          error: () => {
            this.toastr.error(
              'Não foi possível registrar o horário.',
              'Erro'
            );
          }
        });
    });
}
}
